export default __webpack_public_path__ + "fb5b6d3b440f11ffea4642a693fafd8d.svg";